import React, { lazy } from 'react';
import { Quote, Star } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Mi mente no descansaba nunca. Las técnicas del ebook me ayudaron desde el primer día.',
  author: 'Andrea M.',
  age: '34',
  location: 'CDMX',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Dormía súper mal por ansiedad. La rutina nocturna me ayudó muchísimo.',
  author: 'Carlos R.',
  age: '42',
  location: 'Sevilla',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face'
}, {
  quote: 'Me encanta porque son ejercicios rápidos y fáciles de hacer.',
  author: 'Sofía T.',
  age: '29',
  location: 'Buenos Aires',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face'
}];
function StarRow() {
  return <div className="flex gap-0.5" data-id="element-304">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="h-4 w-4 fill-[#C4973B] text-[#C4973B]" data-id="element-305" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-20 bg-[#C06B6B] px-4" data-id="element-306">
      <div className="max-w-6xl mx-auto" data-id="element-307">
        <div className="text-center mb-12" data-id="element-308">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-309">
            Lo que dicen las personas que ya lo probaron
          </h2>
        </div>

        {/* Visual proof bar */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12" data-id="element-310">
          <div className="bg-white rounded-2xl p-6 shadow-lg flex flex-col justify-center" data-id="element-311">
            <div className="flex items-center gap-2 mb-3" data-id="element-312">
              <div className="w-8 h-8 bg-[#FF6B35] rounded-lg flex items-center justify-center" data-id="element-313">
                <span className="text-white text-xs font-bold" data-id="element-314">H</span>
              </div>
              <span className="text-sm font-bold text-gray-700" data-id="element-315">Hotmart</span>
              <span className="ml-auto text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full font-medium" data-id="element-316">
                Verificado
              </span>
            </div>
            <div className="flex items-end gap-2 mb-1" data-id="element-317">
              <span className="text-4xl font-bold text-gray-900" data-id="element-318">4.9</span>
              <span className="text-gray-400 text-sm mb-1" data-id="element-319">/ 5</span>
            </div>
            <StarRow data-id="element-320" />
            <p className="text-xs text-gray-500 mt-2" data-id="element-321">
              Basado en +2,400 compradoras
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg col-span-1 md:col-span-2" data-id="element-322">
            <p className="text-sm font-bold text-gray-700 mb-4" data-id="element-323">
              Distribución de valoraciones
            </p>
            <div className="space-y-2" data-id="element-324">
              {[{
              stars: 5,
              pct: 87
            }, {
              stars: 4,
              pct: 9
            }, {
              stars: 3,
              pct: 3
            }, {
              stars: 2,
              pct: 1
            }, {
              stars: 1,
              pct: 0
            }].map(({
              stars,
              pct
            }) => <div key={stars} className="flex items-center gap-3" data-id="element-325">
                  <span className="text-xs text-gray-500 w-4 text-right" data-id="element-326">
                    {stars}
                  </span>
                  <Star className="h-3 w-3 fill-[#C4973B] text-[#C4973B] flex-shrink-0" data-id="element-327" />
                  <div className="flex-1 bg-gray-100 rounded-full h-2 overflow-hidden" data-id="element-328">
                    <div className="bg-[#C4973B] h-2 rounded-full" style={{
                  width: `${pct}%`
                }} data-id="element-329" />
                  </div>
                  <span className="text-xs text-gray-400 w-8" data-id="element-330">{pct}%</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Testimonial cards — compact */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-331">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-md" data-id="element-332">
              <div className="flex items-center gap-3 mb-3" data-id="element-333">
                <img src={t.avatar} alt={t.author} className="w-10 h-10 rounded-full object-cover ring-1 ring-[#C4973B]/30" loading="lazy" data-id="element-334" />
                <div className="min-w-0" data-id="element-335">
                  <p className="font-bold text-gray-900 text-sm truncate" data-id="element-336">
                    {t.author}
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-337">✓ Compra Verificada</p>
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-338">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}